export default __webpack_public_path__ + "static/logo_soeur-456c5db1118f1213e9132ae77bbff3e2.png";